import {tableAPI} from '../API/api'
import {
    setProductCategoryPricesDispatcher,
    setProductCategoryPromosDispatcher,
    setSupplierPricesDispatcher, setSupplierPromosDispatcher
} from "./format-reducer";

const SET_DATA_TABLE = 'SET_DATA_TABLE';
const SET_DATA_TABLE_FOR_REG_PRICES = 'SET_DATA_TABLE_FOR_REG_PRICES';
const SET_DEFAULT_STATE = 'SET_DEFAULT_STATE';
const DOWNLOAD_HTML = 'DOWNLOAD_HTML';
const DOWNLOAD_HTML_REG_ITEMS = 'DOWNLOAD_HTML_REG_ITEMS';
const IS_PRELOADER = 'IS_PRELOADER';
const GET_STATE_DATE_TABLE = 'GET_STATE_DATE_TABLE';
const SELECT_SOME_ITEM_IN_BRANCH = 'SELECT_SOME_ITEM_IN_BRANCH';
const SELECT_SOME_ITEM_IN_BRANCH_PRICES_TABLE = 'SELECT_SOME_ITEM_IN_BRANCH_PRICES_TABLE';
const SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH = 'SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH';
const SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH = 'SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH';
const SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS = 'SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS';
const SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS = 'SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS';
const SELECT_FULL_BRANCH = 'SELECT_FULL_BRANCH';
const SELECT_FULL_BRANCH_FOR_PRICES_TABLE = 'SELECT_FULL_BRANCH_FOR_PRICES_TABLE';
const SORT_TABLE = 'SORT_TABLE';
const SORT_TABLE_FOR_PRICES = 'SORT_TABLE_FOR_PRICES';
const PRINT_FORMAT = 'PRINT_FORMAT';
const PRINT_FORMAT_REG_ITEMS = 'PRINT_FORMAT_REG_ITEMS';
const ERROR_POPUP = 'ERROR_POPUP';
const COLLECT_SELECTED_ROWS_IDS = 'COLLECT_SELECTED_ROWS_IDS';
const IS_DATA_PRINT = 'IS_DATA_PRINT';
const CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW = 'CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW';
const CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW_IN_PRICE_TABLE = 'CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW_IN_PRICE_TABLE';
const IS_ACTIVE_PROMOTION_SCREEN = 'IS_ACTIVE_PROMOTION_SCREEN';
const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
const CHANGE_PRINT_LIST_FOR_PROMOS = `CHANGE_PRINT_LIST_FOR_PROMOS`;
const CHANGE_PRINT_LIST_FOR_ITEMS = `CHANGE_PRINT_LIST_FOR_ITEMS`;
const TOGGLE_PRINT_LIST = `TOGGLE_PRINT_LIST`;

let initialState = {
    data: [],
    defaultDataForPromos: [],
    dataForRegPrices: [],
    defaultDataForItems: [],
    dataPrint: '',
    isDataPrintForIcon: false,
    isDataPrintForButton: false,
    isPreloader: true,
    referenceNo: 1,
    isSelectAll: false,
    isErrorPopupShow: false,
    errorBody: '',
    selectedIds: [],
    isActivePromosScreen: false,
    ProductCategoryNames: [],
    SupplierNames: [],
    searchValue: ``,
    printListDataForPromos: [],
    printListDataForItems: [],
    isPrintListOpened: false
};

const tableReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_PRINT_LIST: {
            return {
                ...state,
                data: state.defaultDataForPromos,
                dataForRegPrices: state.defaultDataForItems,
                isPrintListOpened: !action.isOpen
            }
        }
        case CHANGE_PRINT_LIST_FOR_PROMOS: {
            return {
                ...state,
                printListDataForPromos: action.printListForPromos
            }
        }
        case CHANGE_PRINT_LIST_FOR_ITEMS: {
            return {
                ...state,
                printListDataForItems: action.printListForItems
            }
        }
        case SET_DEFAULT_STATE: {
            return {
                ...state,
                data: [],
                dataForRegPrices: [],
                selectedIds: [],
                isSelectAll: false,
                isErrorPopupShow: false,
                errorBody: '',
                defaultDataForPromos: [],
                defaultDataForItems: [],
            }
        }
        case SET_DATA_TABLE: {
            if(action.withoutUpdateDropdowns){
                return {
                    ...state,
                    data: action.data,
                    defaultDataForPromos: action.data,
                }
            } else {
                return {
                    ...state,
                    data: action.data,
                    defaultDataForPromos: action.data,
                    ProductCategoryNames: action.productCategoryNames,
                    SupplierNames: action.supplierNames
                }
            }
        }
        case SET_DATA_TABLE_FOR_REG_PRICES: {
            if(action.withoutUpdateDropdowns){
                return {
                    ...state,
                    dataForRegPrices: action.data,
                    defaultDataForItems: action.data,
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: action.data,
                    defaultDataForItems: action.data,
                    ProductCategoryNames: action.productCategoryNames,
                    SupplierNames: action.supplierNames
                }
            }
        }
        case SORT_TABLE: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForPromos: action.data.map((key, index) => {
                        // if(key.SaleType === 1){
                        key.rowIndex = index+1;
                        // }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    data: action.data.map((key, index) => {
                        // if(key.SaleType === 1){
                        key.rowIndex = index+1;
                        // }
                        return key;
                    })

                }
            }
        }
        case SORT_TABLE_FOR_PRICES: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForItems: action.data.map((key, index) => {
                        // if(key.SaleType === 1){
                        key.rowIndex = index+1;
                        // }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: action.data.map((key, index) => {
                        // if(key.SaleType === 1){
                        key.rowIndex = index+1;
                        // }
                        return key;
                    })
                }
            }
        }
        case COLLECT_SELECTED_ROWS_IDS: {
            return {
                ...state,
                selectedIds: action.ids
            }
        }
        case DOWNLOAD_HTML: {
            return {
                ...state,
                isDataPrintForIcon: action.forOneTr,
                isDataPrintForButton: !action.forOneTr,
                dataPrint: action.data
            }
        }
        case DOWNLOAD_HTML_REG_ITEMS: {
            return {
                ...state,
                isDataPrintForIcon: action.forOneTr,
                isDataPrintForButton: !action.forOneTr,
                dataPrint: action.data
            }
        }
        case IS_PRELOADER: {
            return {
                ...state,
                isPreloader: action.isPreloader
            }
        }
        case GET_STATE_DATE_TABLE: {
            return state;
        }
        case SELECT_SOME_ITEM_IN_BRANCH: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForPromos: state.printListDataForPromos.map((key) =>{
                        if(action.saleIdentifier === key.SaleIdentifier){
                            key.selectedRow = action.isSelected;
                            key.isLastSelected = action.isLastSelected;
                        } else {
                            key.isLastSelected = false;
                        }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    data: state.data.map((key) =>{
                        if(action.saleIdentifier === key.SaleIdentifier){
                            key.selectedRow = action.isSelected;
                            key.isLastSelected = action.isLastSelected;
                        } else {
                            key.isLastSelected = false;
                        }
                        return key;
                    })
                }
            }
        }
        case SELECT_SOME_ITEM_IN_BRANCH_PRICES_TABLE: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForItems: state.printListDataForItems.map((key) =>{
                        if(action.effectiveBarCode === key.EffectiveBarCode){
                            key.selectedRow = action.isSelected;
                            key.isLastSelected = action.isLastSelected;
                        } else {
                            key.isLastSelected = false;
                        }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: state.dataForRegPrices.map((key) =>{
                        if(action.effectiveBarCode === key.EffectiveBarCode){
                            key.selectedRow = action.isSelected;
                            key.isLastSelected = action.isLastSelected;
                        } else {
                            key.isLastSelected = false;
                        }
                        return key;
                    })
                }
            }
        }
        case SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForPromos: state.printListDataForPromos.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex <= key.rowIndex && action.indexForEndRange >= key.rowIndex;
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    data: state.data.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex <= key.rowIndex && action.indexForEndRange >= key.rowIndex;
                        return key;
                    })
                }
            }
        }
        case SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForPromos: state.printListDataForPromos.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex >= key.rowIndex && action.indexForEndRange <= key.rowIndex;
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    data: state.data.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex >= key.rowIndex && action.indexForEndRange <= key.rowIndex;
                        return key;
                    })
                }
            }
        }
        case SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForItems: state.printListDataForItems.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex <= key.rowIndex && action.indexForEndRange >= key.rowIndex;
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: state.dataForRegPrices.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex <= key.rowIndex && action.indexForEndRange >= key.rowIndex;
                        return key;
                    })
                }
            }
        }
        case SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForItems: state.printListDataForItems.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex >= key.rowIndex && action.indexForEndRange <= key.rowIndex;
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: state.dataForRegPrices.map((key) =>{
                        key.selectedRow = action.lastSelectedRowIndex >= key.rowIndex && action.indexForEndRange <= key.rowIndex;
                        return key;
                    })
                }
            }
        }
        case SELECT_FULL_BRANCH: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    isSelectAll: action.isSelected,
                    printListDataForPromos: state.printListDataForPromos.map((key, index) =>{
                        // if(key.SaleType === 1){
                        key.selectedRow = action.isSelected;
                        key.isLastSelected = index === 0;
                        // }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    isSelectAll: action.isSelected,
                    data: state.data.map((key, index) =>{
                        // if(key.SaleType === 1){
                        key.selectedRow = action.isSelected;
                        key.isLastSelected = index === 0;
                        // }
                        return key;
                    })
                }
            }
        }
        case SELECT_FULL_BRANCH_FOR_PRICES_TABLE: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    isSelectAll: action.isSelected,
                    printListDataForItems: state.printListDataForItems.map((key, index) =>{
                        // if(key.SaleType === 1){
                        key.selectedRow = action.isSelected;
                        key.isLastSelected = index === 0;
                        // }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    isSelectAll: action.isSelected,
                    dataForRegPrices: state.dataForRegPrices.map((key, index) =>{
                        // if(key.SaleType === 1){
                        key.selectedRow = action.isSelected;
                        key.isLastSelected = index === 0;
                        // }
                        return key;
                    })
                }
            }
        }
        case ERROR_POPUP: {
            return {
                ...state,
                isErrorPopupShow: action.isErrorPopupShow,
                errorBody: action.errorBody
            }
        }
        case PRINT_FORMAT: {
            return {
                ...state,
                isDataPrintForIcon: false,
                isDataPrintForButton: false,
                data: state.data.map((key) =>{
                    const data = action.saleRecIDs;
                    const format = data.find((elem) => elem === key.SaleIdentifier);
                    if(format){
                        if(!key.PrintedPageSizes.includes(action.pageSize)){
                            console.log(key.PrintedPageSizes);
                            key.PrintedPageSizes.push(action.pageSize);
                            console.log(key.PrintedPageSizes);
                            key.isAlreadyPrinted = true;
                        }
                    }
                    return key;
                }),
                printListDataForPromos: state.printListDataForPromos.map((key) =>{
                    const data = action.saleRecIDs;
                    const format = data.find((elem) => elem === key.SaleIdentifier);
                    if(format){
                        if(!key.PrintedPageSizes.includes(action.pageSize)){
                            console.log(key.PrintedPageSizes);
                            key.PrintedPageSizes.push(action.pageSize);
                            console.log(key.PrintedPageSizes);
                            key.isAlreadyPrinted = true;
                        }
                    }
                    return key;
                })
            }
        }
        case PRINT_FORMAT_REG_ITEMS: {
            return {
                ...state,
                isDataPrintForIcon: false,
                isDataPrintForButton: false,
                dataForRegPrices: state.dataForRegPrices.map((key) =>{
                    const data = action.effectiveBarCodes;
                    const format = data.find((elem) => elem === key.EffectiveBarCode);
                    if(format){
                        if(!key.PrintedPageSizes.includes(action.pageSize)){
                            console.log(key.PrintedPageSizes);
                            key.PrintedPageSizes.push(action.pageSize);
                            console.log(key.PrintedPageSizes);
                            key.isAlreadyPrinted = true;
                        }
                    }
                    return key;
                }),
                printListDataForItems: state.printListDataForItems.map((key) =>{
                    const data = action.effectiveBarCodes;
                    const format = data.find((elem) => elem === key.EffectiveBarCode);
                    if(format){
                        if(!key.PrintedPageSizes.includes(action.pageSize)){
                            console.log(key.PrintedPageSizes);
                            key.PrintedPageSizes.push(action.pageSize);
                            console.log(key.PrintedPageSizes);
                            key.isAlreadyPrinted = true;
                        }
                    }
                    return key;
                })
            }
        }
        case IS_DATA_PRINT: {
            return {
                ...state,
                isDataPrintForIcon: action.isActive,
                isDataPrintForButton: action.isActive
            }
        }

        case CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForPromos: state.printListDataForPromos.map((key) => {
                        if(key.SaleIdentifier === action.promoId){
                            key.numberOfCopies = action.numbersOfCopies;
                        }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    data: state.data.map((key) => {
                        if(key.SaleIdentifier === action.promoId){
                            key.numberOfCopies = action.numbersOfCopies;
                        }
                        return key;
                    })
                }
            }
        }
        case CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW_IN_PRICE_TABLE: {
            if(state.isPrintListOpened){
                return {
                    ...state,
                    printListDataForItems: state.printListDataForItems.map((key) => {
                        if(key.EffectiveBarCode === action.effectiveBarCode){
                            key.numberOfCopies = action.numbersOfCopies;
                        }
                        return key;
                    })
                }
            } else {
                return {
                    ...state,
                    dataForRegPrices: state.dataForRegPrices.map((key) => {
                        if(key.EffectiveBarCode === action.effectiveBarCode){
                            key.numberOfCopies = action.numbersOfCopies;
                        }
                        return key;
                    })
                }

            }
        }
        case IS_ACTIVE_PROMOTION_SCREEN: {
            return {
                ...state,
                isActivePromosScreen: action.isActive
            }
        }
        case SET_SEARCH_VALUE: {
            return {
                ...state,
                searchValue: action.value
            }
        }
        default:
            return state;
    }
};


export const setDefaultState = () => ({type: SET_DEFAULT_STATE});
export const setDataTable = (data, productCategoryNames, supplierNames, withoutUpdateDropdowns) => ({type: SET_DATA_TABLE, data, productCategoryNames, supplierNames, withoutUpdateDropdowns});
export const setDataTableForRegPrices = (data, productCategoryNames, supplierNames, withoutUpdateDropdowns) => ({type: SET_DATA_TABLE_FOR_REG_PRICES, data, productCategoryNames, supplierNames, withoutUpdateDropdowns});
export const setPrintFormat = (branchId, pageSize, saleRecIDs) => ({type: PRINT_FORMAT, branchId, pageSize, saleRecIDs});
export const setPrintFormatRegItems = (branchId, pageSize, effectiveBarCodes) => ({type: PRINT_FORMAT_REG_ITEMS, branchId, pageSize, effectiveBarCodes});
export const sortDataTableAction = (data) => ({type: SORT_TABLE, data});
export const sortDataTableForPricesAction = (data) => ({type: SORT_TABLE_FOR_PRICES, data});
export const downLoadData = (data, forOneTr) => ({type: DOWNLOAD_HTML, data, forOneTr});
export const downLoadDataRegItems = (data, forOneTr) => ({type: DOWNLOAD_HTML_REG_ITEMS, data, forOneTr});
export const setPreloader = (isPreloader) => ({type: IS_PRELOADER, isPreloader});
export const getStateDataTable = () => ({type: GET_STATE_DATE_TABLE});
export const showErrorPopup = (isErrorPopupShow, errorBody) => ({type: ERROR_POPUP, isErrorPopupShow, errorBody});
export const changeSelectedIds = (ids) => ({type: COLLECT_SELECTED_ROWS_IDS, ids});
export const changeDataPrintStatus = (isActive) => ({type: IS_DATA_PRINT, isActive});
export const changeNumberOfCopiesForSelectedRowAction = (promoId, numbersOfCopies) => ({type: CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW, promoId, numbersOfCopies});
export const changeNumberOfCopiesForSelectedRowForPriceTableAction = (effectiveBarCode, numbersOfCopies) => ({type: CHANGE_NUMBER_OF_COPIES_FOR_TARGET_ROW_IN_PRICE_TABLE, effectiveBarCode, numbersOfCopies});
export const setActivePromotionsScreenAction = (isActive) => ({type: IS_ACTIVE_PROMOTION_SCREEN, isActive});
export const setSearchValueAction = (value) => ({type: SET_SEARCH_VALUE, value});
export const isSelectedRow = (isSelected, saleIdentifier, isLastSelected) => ({
    type: SELECT_SOME_ITEM_IN_BRANCH,
    isSelected,
    saleIdentifier,
    isLastSelected
});

export const isSelectedRowForPricesTable = (isSelected, effectiveBarCode, isLastSelected) => ({
    type: SELECT_SOME_ITEM_IN_BRANCH_PRICES_TABLE,
    isSelected,
    effectiveBarCode,
    isLastSelected
});

export const getRangeAfterLastSelectedRow = (lastSelectedRowIndex, indexForEndRange) => ({
    type: SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH,
    lastSelectedRowIndex,
    indexForEndRange
});

export const getRangeBeforeLastSelectedRow = (lastSelectedRowIndex, indexForEndRange) => ({
    type: SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH,
    lastSelectedRowIndex,
    indexForEndRange
});

export const getRangeAfterLastSelectedRowRegItemsAction = (lastSelectedRowIndex, indexForEndRange) => ({
    type: SELECT_RANGE_AFTER_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS,
    lastSelectedRowIndex,
    indexForEndRange
});

export const getRangeBeforeLastSelectedRowRegItemsAction = (lastSelectedRowIndex, indexForEndRange) => ({
    type: SELECT_RANGE_BEFORE_LAST_SELECTED_ROW_IN_BRANCH_REG_ITEMS,
    lastSelectedRowIndex,
    indexForEndRange
});

export const isSelectedFullBranch = (isSelected) => ({type: SELECT_FULL_BRANCH, isSelected});
export const isSelectedFullBranchForPricesTable = (isSelected) => ({type: SELECT_FULL_BRANCH_FOR_PRICES_TABLE, isSelected});
export const addPromosToPrintListAction = (printListForPromos) => ({type: CHANGE_PRINT_LIST_FOR_PROMOS, printListForPromos});
export const addItemsToPrintListAction = (printListForItems) => ({type: CHANGE_PRINT_LIST_FOR_ITEMS, printListForItems});
export const togglePrintListAction = (isOpen) => ({type: TOGGLE_PRINT_LIST, isOpen});


export const togglePrintListDispatcher = (isOpen) => {
    return (dispatch) => {
        dispatch(togglePrintListAction(isOpen));
    }
};

export const addPromosToPrintListDispatcher = (printListForPromos) => {
    return (dispatch) => {
        dispatch(addPromosToPrintListAction(printListForPromos));
    }
};
export const addItemsToPrintListDispatcher = (printListForItems) => {
    return (dispatch) => {
        dispatch(addItemsToPrintListAction(printListForItems));
    }
};
export const setDefaultStateForApp = () => {
    return (dispatch) => {
        dispatch(setDefaultState())
    }
};

export const sortDataTable = (data) => {
    return (dispatch) => {
        dispatch(sortDataTableAction(data))
    }
};
export const sortDataTableForPrices = (data) => {
    return (dispatch) => {
        dispatch(sortDataTableForPricesAction(data))
    }
};

export const setRangeAfterLastSelectedRow = (lastSelectedRowIndex, indexForEndRange) => {
    return (dispatch) => {
        dispatch(getRangeAfterLastSelectedRow(lastSelectedRowIndex, indexForEndRange))
    }
};

export const setRangeBeforeLastSelectedRow = (lastSelectedRowIndex, indexForEndRange) => {
    return (dispatch) => {
        dispatch(getRangeBeforeLastSelectedRow(lastSelectedRowIndex, indexForEndRange))
    }
};

export const setRangeAfterLastSelectedRowRegItemsDispatcher = (lastSelectedRowIndex, indexForEndRange) => {
    return (dispatch) => {
        dispatch(getRangeAfterLastSelectedRowRegItemsAction(lastSelectedRowIndex, indexForEndRange))
    }
};

export const setRangeBeforeLastSelectedRowRegItemsDispatcher = (lastSelectedRowIndex, indexForEndRange) => {
    return (dispatch) => {
        dispatch(getRangeBeforeLastSelectedRowRegItemsAction(lastSelectedRowIndex, indexForEndRange))
    }
};

export const setSelectedRow = (isSelected, saleIdentifier, isLastSelected) => {
    return (dispatch) => {
        dispatch(isSelectedRow(isSelected, saleIdentifier, isLastSelected))
    }
};
export const setSelectedRowForPricesTable = (isSelected, effectiveBarCode, isLastSelected) => {
    return (dispatch) => {
        dispatch(isSelectedRowForPricesTable(isSelected, effectiveBarCode, isLastSelected))
    }
};
export const setSelectedFullBranch = (isSelected) => {
    return (dispatch) => {
        dispatch(isSelectedFullBranch(isSelected))
    }
};

export const setSelectedFullBranchForPricesTable = (isSelected) => {
    return (dispatch) => {
        dispatch(isSelectedFullBranchForPricesTable(isSelected))
    }
};


export const getDataTable = (branchNo, format, supplierName, productCategoryName, keywords, withoutUpdateDropdowns) => {
    return (dispatch) => {
        tableAPI.getDataTable(branchNo, format, supplierName, productCategoryName, keywords)
            .then(data => {
                let modifiedData = data.BranchPrintablePricezPromos.map((item, index) => {
                    let isAlreadyPrinted = false;
                    const promoWhichIncludeSelectedSize = item.PrintedPageSizes.find((size) => size === format);
                    if(promoWhichIncludeSelectedSize){
                        isAlreadyPrinted = true;
                    }
                    // item.PrintedPageSizes.forEach((key) => {
                    //     if(key === format){
                    //         isAlreadyPrinted = true;
                    //     }
                    // });
                    return {
                        ...item,
                        selectedRow: false,
                        isLastSelected: false,
                        rowIndex: index+1,
                        isAlreadyPrinted: isAlreadyPrinted,
                        numberOfCopies: 1
                    }
                });
                localStorage.setItem('selectedOptionValue', branchNo);
                const printPromosList = JSON.parse(localStorage.getItem(`printListForPromos${branchNo}`)) === null ? [] : JSON.parse(localStorage.getItem(`printListForPromos${branchNo}`));
                dispatch(addPromosToPrintListDispatcher(printPromosList));
                if(keywords === ``){
                   dispatch(setSearchValueAction(``));
                }
                if(!productCategoryName){
                    dispatch(setProductCategoryPromosDispatcher(``));
                }
                if(!supplierName){
                    dispatch(setSupplierPromosDispatcher(``));
                }

                dispatch(setDataTable(modifiedData, data.ProductCategoryNames, data.SupplierNames, withoutUpdateDropdowns));
                dispatch(setPreloader(false));
            })
            .catch(err => {
                localStorage.setItem('selectedOptionValue', branchNo);
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })
    }
};

export const getDataTableForRegularPrices = (branchNo, format, supplierName, productCategoryName, keywords, withoutUpdateDropdowns) => {
    return (dispatch) => {
        tableAPI.getDataTableForRegularPrices(branchNo, format, supplierName, productCategoryName, keywords)
            .then(data => {
                let modifiedData = data.BranchPrintablePricezRegularItems.map((item, index) => {
                    let isAlreadyPrinted = false;
                    const promoWhichIncludeSelectedSize = item.PrintedPageSizes.find((size) => size === format);
                    if(promoWhichIncludeSelectedSize){
                        isAlreadyPrinted = true;
                    }
                    // item.PrintedPageSizes.forEach((key) => {
                    //     if(key === format){
                    //         isAlreadyPrinted = true;
                    //     }
                    // });
                    return {
                        ...item,
                        selectedRow: false,
                        isLastSelected: false,
                        rowIndex: index+1,
                        isAlreadyPrinted: isAlreadyPrinted,
                        numberOfCopies: 1
                    }
                });
                localStorage.setItem('selectedOptionValue', branchNo);
                const printItemsList = JSON.parse(localStorage.getItem(`printListForItems${branchNo}`)) === null ? [] : JSON.parse(localStorage.getItem(`printListForItems${branchNo}`));
                dispatch(addItemsToPrintListDispatcher(printItemsList));
                if(keywords === ``){
                    dispatch(setSearchValueAction(``));
                }
                if(!productCategoryName){
                    dispatch(setProductCategoryPricesDispatcher(``));
                }
                if(!supplierName){
                    dispatch(setSupplierPricesDispatcher(``));
                }
                dispatch(setDataTableForRegPrices(modifiedData, data.ProductCategoryNames, data.SupplierNames, withoutUpdateDropdowns));
                dispatch(setPreloader(false));
            })
            .catch(err => {
                localStorage.setItem('selectedOptionValue', branchNo);
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })
    }
};

export const getDataForDownload = (pageSize, saleData, branchId, forOneTr) => {
    return (dispatch) => {
        tableAPI.getBranchPricezPromosSignage(pageSize, saleData, branchId)
            .then(data => {
                dispatch(downLoadData(data.data, forOneTr));
            })
            .catch(err => {
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })

    }

};

export const getDataForDownloadRegItems = (pageSize, regItemsData, branchId, forOneTr) => {
    return (dispatch) => {
        tableAPI.getBranchPricesRegularItemsSignage(pageSize, regItemsData, branchId)
            .then(data => {
                dispatch(downLoadDataRegItems(data.data, forOneTr));
            })
            .catch(err => {
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })

    }

};

export const sendSaleIdsToServer = (branchId, pageSize, saleRecIDs) => {
    return (dispatch) => {
        tableAPI.RegisterPricezPromosSignagePrinting(branchId, pageSize, saleRecIDs)
            .then(data => {
                console.log(data);
                dispatch(setPrintFormat(branchId, pageSize, saleRecIDs));
                const storagePromosFromBranch = JSON.parse(localStorage.getItem(`printListForPromos${branchId}`));
                if(storagePromosFromBranch && storagePromosFromBranch.length){
                    const newPromosArrayForStorage = storagePromosFromBranch.map((key) => {
                        const format = saleRecIDs.find((elem) => elem === key.SaleIdentifier);
                        if(format){
                            if(!key.PrintedPageSizes.includes(pageSize)){
                                key.PrintedPageSizes.push(pageSize);
                                key.isAlreadyPrinted = true;
                            }
                        }
                        return key;
                    })
                    localStorage.setItem(`printListForPromos${branchId}`, JSON.stringify(newPromosArrayForStorage));
                }
            })
            .catch(err => {
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })
    }
};

export const sendEffectiveBarCodesToServer = (branchId, pageSize, effectiveBarCodes) => {
    return (dispatch) => {
        tableAPI.RegisterPricesRegularItemsSignagePrinting(branchId, pageSize, effectiveBarCodes)
            .then(data => {
                console.log(data);
                dispatch(setPrintFormatRegItems(branchId, pageSize, effectiveBarCodes));
                const storageItemsFromBranch = JSON.parse(localStorage.getItem(`printListForItems${branchId}`));
                if(storageItemsFromBranch && storageItemsFromBranch.length){
                    const newPromosArrayForStorage = storageItemsFromBranch.map((key) => {
                        const format = effectiveBarCodes.find((elem) => elem === key.EffectiveBarCode);
                        if(format){
                            if(!key.PrintedPageSizes.includes(pageSize)){
                                key.PrintedPageSizes.push(pageSize);
                                key.isAlreadyPrinted = true;
                            }
                        }
                        return key;
                    })
                    localStorage.setItem(`printListForItems${branchId}`, JSON.stringify(newPromosArrayForStorage));
                }
            })
            .catch(err => {
                dispatch(showErrorPopup(true, err));
                dispatch(setPreloader(false));
            })
    }
};

export const getStateForTable = () => {
    return (dispatch) => {
        dispatch(getStateDataTable())
    }
};

export const setDataPrintStatus = (isActive) => {
    return (dispatch) => {
        dispatch(changeDataPrintStatus(isActive))
    }
};

export const changeNumberOfCopiesForSelectedRow = (promoId, numberOfCopies) => {
    return (dispatch) => {
        dispatch(changeNumberOfCopiesForSelectedRowAction(promoId, numberOfCopies))
    }
};
export const changeNumberOfCopiesForSelectedRowForPriceTable = (effectiveBarCode, numberOfCopies) => {
    return (dispatch) => {
        dispatch(changeNumberOfCopiesForSelectedRowForPriceTableAction(effectiveBarCode, numberOfCopies))
    }
};

export const setActivePromotionsScreen = (isActive) => {
    return (dispatch) => {
        dispatch(setActivePromotionsScreenAction(isActive))
    }
};

export default tableReducer;